import { createAction } from 'redux-actions';

import { READ_MESSAGES } from '../constants/Actions';

export default createAction(READ_MESSAGES);
